import axios from "axios";

export const reviewsData = () => {
    return axios
      .get("/reviews")
      .then((response) => {
        // console.log(response.data);
        return response;
      });
  };